import { Container, IDestroyOptions } from "pixi.js";
import { gsap } from "gsap/gsap-core";
import { CustomEase } from "gsap/CustomEase";

export class CircleScrollItem extends Container {
    private readonly rotationTimeline: gsap.core.Timeline;
    private readonly rotationEase: gsap.EaseFunction;
    private animationRotation: number = 0;

    public constructor() {
        super();
        this.rotationTimeline = new gsap.core.Timeline({ paused: true });
        this.rotationEase = CustomEase.create("custom", "M0,0 C0.146,-0.73 0.25,0.263 0.278,0.408 0.309,0.572 0.396,1.144 0.52,1.145 0.607,1.145 0.654,0.739 0.694,0.478 0.723,0.281 0.732,-0.123 0.813,-0.123 0.914,-0.123 0.906,0.132 0.945,0.132 0.987,0.132 1,0 1,0 ");
    }

    public async startRotation(angle: number): Promise<void> {
        this.rotationTimeline.clear();
        this.rotationTimeline.fromTo(this, { animationRotation: 0 }, { animationRotation: angle, duration: 2.0, ease: this.rotationEase }, ">");
        await this.rotationTimeline.play();
    }

    public override updateTransform(): void {
        super.updateTransform();
        this.rotation = this.animationRotation - this.parent.rotation;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.rotationTimeline.kill();
        super.destroy(options);
    }
}